// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"47e5992f","921":"cac8c8ef"}[chunkId] + ".chunk.js";
};